module.exports = __webpack_public_path__ + "static/media/launching-distilled-id-sq.c0eb7c62.jpg";